import {Component, OnInit} from '@angular/core';
import {ActivePageHelperService} from './services/helpers/active-page-helper.service';
import {EchoHelperService} from './services/helpers/echo-helper.service';
import {AuthenticationHelperService} from './services/helpers/authentication-helper.service';
import {PAGES_AND_PATHS} from './constants/pages-and-paths';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  constructor(private echoHelperService: EchoHelperService,
              public activePageHelper: ActivePageHelperService,
              public authHelperService: AuthenticationHelperService,
              private translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.translateService.use('en'); //<< -- Defvault-ni jezik je ENGLESKI
    this.initializeApp();
    console.log('d', this.activePageHelper.activePage);
  }

  initializeApp(): void {
    this.authHelperService.authStatus$.subscribe((userData: boolean) => {
      if (userData) {
        this.echoHelperService.initEcho();
        // if (this.authHelperService.getAuthUserRole === UserRoles.user) {
        //   this.getAdministrationsAndDeliveryCost();
        // }
      }
    });
  }
}
